var _rect, _rect2, _rect3, _circle, _path, _path2, _ellipse, _ellipse2, _ellipse3, _path3, _g, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 900 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of New Caledonia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#009543",
    width: 900,
    height: 450
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ed4135",
    width: 900,
    height: 300
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0035ad",
    width: 900,
    height: 150
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "#000",
    strokeWidth: 5,
    fill: "#fae600",
    cx: 300,
    cy: 225,
    r: 147.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 6,
    d: "M275,247h50 M275,210h50 M300,78V330"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.62,360.419  C300.811,384.999,357.228,361.929,357.228,361.929  C357.228,361.929,335.931,338.881,325.014,329.882  C314.361,321.104,283.023,321.451,272.329,329.882  C263.405,336.92,237.809,362.852,240.62,360.419Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 293,
    rx: 16.5,
    ry: 24
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 228.5,
    rx: 20,
    ry: 12.66
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 170,
    rx: 20,
    ry: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324,95.5  C323.994,95.4866,325.733,98.3708,322.087,104.936  C304.661,136.319,287.174,136.997,283.855,139.7  C280.197,142.678,278.653,142.474,278.653,142.474  C278.914,139.786,279.157,128.795,279.348,127.736  C281.993,113.073,304.144,113.275,321.48,98.2605  C324.188,95.915,323.994,95.4866,323.994,95.4866Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leaf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 265.5,163   c0,0 3.91436,11.22974 4.5,22.5   c0.93516,17.99657 18.18031,18.5 30,18.5   l0,-10   c-8.85851,0 -16.55267,-1.31658 -23,-14.5   c-3.18045,-6.50336 -11.5,-16.5 -11.5,-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 265,308   c0,0 6.29638,-7.76543 13.6619,-25.97461   C282.5048,272.5249 291.6115,267 300,267   l0,-14   c-19.02757,0 -28.1503,7.0552 -29.11281,17.36332   C268.90975,291.54089 265,308 265,308z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    transform: "translate(600,0)scale(-1,1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNc);
export default __webpack_public_path__ + "static/media/nc.2ebfe2590a9e440fba0af3c13143a9b4.svg";
export { ForwardRef as ReactComponent };